/**
 * Pre-populate Globo Form Builder "Gun Model" field with product title
 * Used on POA (Price on Application) product pages
 */
(function() {
  'use strict';

  function setupGloboFormPrefill() {
    const button = document.querySelector('.globo-formbuilder-open[data-product-title]');
    if (!button) {
      setTimeout(setupGloboFormPrefill, 500);
      return;
    }
    
    button.addEventListener('click', function(e) {
      const productTitle = button.getAttribute('data-product-title');
      
      let fieldPopulated = false;
      
      // Function to try populating the field
      function tryPopulateField() {
        if (fieldPopulated) return; // Already done
        
        // Find the modal first - try multiple selectors
        let modal = document.querySelector('.globo-form-publish-modal');
        if (!modal) modal = document.querySelector('.globo-form-app');
        if (!modal) modal = document.querySelector('.globo-form-modal-content');
        if (!modal) modal = document.querySelector('[class*="globo-form"]');
        
        // Also check for iframes (Globo might load form in iframe)
        let iframe = null;
        if (!modal) {
          iframe = document.querySelector('iframe[src*="globo"], iframe[src*="form"]');
          if (iframe && iframe.contentDocument) {
            modal = iframe.contentDocument.querySelector('.globo-form-app, .globo-form-publish-modal');
          }
        }
        
        if (!modal && !iframe) return false; // Not ready yet
        
        // Get all form fields - from modal or iframe
        let allFields = [];
        if (iframe && iframe.contentDocument) {
          allFields = Array.from(iframe.contentDocument.querySelectorAll('input, textarea, select'));
        } else if (modal) {
          allFields = Array.from(modal.querySelectorAll('input, textarea, select'));
        }
        
        if (allFields.length === 0) return false; // No fields yet
        
        // Find the Gun Model field by searching label text
        let targetField = null;
        const searchDoc = iframe && iframe.contentDocument ? iframe.contentDocument : (modal || document);
        const labels = searchDoc.querySelectorAll('label');
        
        for (let label of labels) {
          const labelText = label.textContent.toLowerCase();
          if (labelText.includes('gun') && labelText.includes('model')) {
            const fieldId = label.getAttribute('for');
            if (fieldId) {
              try {
                targetField = searchDoc.querySelector('#' + CSS.escape(fieldId));
              } catch(e) {
                try {
                  targetField = searchDoc.querySelector('[id="' + fieldId + '"]');
                } catch(e2) {}
              }
              if (targetField) break;
            }
            targetField = label.querySelector('input, textarea, select');
            if (targetField) break;
          }
        }
        
        // If found, populate it
        if (targetField && targetField.offsetParent !== null) {
          targetField.value = productTitle;
          targetField.dispatchEvent(new Event('change', { bubbles: true }));
          targetField.dispatchEvent(new Event('input', { bubbles: true }));
          targetField.dispatchEvent(new Event('blur', { bubbles: true }));
          fieldPopulated = true;
          return true;
        }
        
        return false;
      }
      
      // Use MutationObserver for instant detection
      const observer = new MutationObserver(function(mutations) {
        if (tryPopulateField()) {
          observer.disconnect();
        }
      });
      
      // Start observing immediately
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
      
      // Also try immediately and with small intervals as fallback
      tryPopulateField();
      
      // Fast polling for first 2 seconds, then slower
      let attempts = 0;
      const fastCheck = setInterval(function() {
        attempts++;
        if (tryPopulateField()) {
          clearInterval(fastCheck);
          observer.disconnect();
          return;
        }
        
        // After 2 seconds, switch to slower checking
        if (attempts >= 40) { // 40 * 50ms = 2 seconds
          clearInterval(fastCheck);
          
          // Slower fallback check
          const slowCheck = setInterval(function() {
            if (tryPopulateField() || attempts >= 200) { // 200 * 100ms = 20 seconds total
              clearInterval(slowCheck);
              observer.disconnect();
            }
          }, 100);
        }
      }, 50); // Check every 50ms for fast response
    });
  }
  
  // Try immediately and after delays
  setupGloboFormPrefill();
  setTimeout(setupGloboFormPrefill, 500);
  setTimeout(setupGloboFormPrefill, 2000);
})();
